module.exports = __webpack_public_path__ + "img/playace.83eccba1.jpg";